export const GET_LOCATION_REQUEST = 'GET_LOCATION_REQUEST' as const;
export const GET_LOCATION_SUCCESS = 'GET_LOCATION_SUCCESS' as const;
export const GET_LOCATION_ERROR = 'GET_LOCATION_ERROR' as const;

export const ORDER_ADD_BLLIST_REQUEST = 'ORDER_ADD_BLLIST_REQUEST' as const;
export const ORDER_ADD_BLLIST_SUCCESS = 'ORDER_ADD_BLLIST_SUCCESS' as const;
export const ORDER_ADD_BLLIST_ERROR = 'ORDER_ADD_BLLIST_ERROR' as const;

export const ORDER_GET_USER_ID_REQUEST = 'ORDER_GET_USER_ID_REQUEST' as const;
export const ORDER_GET_USER_ID_SUCCESS = 'ORDER_GET_USER_ID_SUCCESS' as const;
export const ORDER_GET_USER_ID_ERROR = 'ORDER_GET_USER_ID_ERROR' as const;

export const ADD_USER_ID_REQUEST = 'ADD_USER_ID_REQUEST' as const;
export const ADD_USER_ID_SUCCESS = 'ADD_USER_ID_SUCCESS' as const;
export const ADD_USER_ID_ERROR = 'ADD_USER_ID_ERROR' as const;

export const ORDER_CLEAN_ERROR = 'ORDER_CLEAN_ERROR' as const;
